import { gsap, Power1 } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', function() {
    gsap.registerPlugin(ScrollTrigger);
    
    window.privacyWaypoints = function() {
        const nav = document.getElementsByClassName('js-privacyindex')[0].getElementsByTagName('li');
        
        const action = function(e) {
            let id = e.id;

            for (let i = 0; i < nav.length; i++) {
                nav[i]. classList.remove('is-active');
            }
            
            document.querySelector("li[data-target='#"+id+"']").classList.add('is-active');
        }
        
        const actionBack = function(e) {
            let id = e.id;
            
            console.clear();

            let previousDiv = document.getElementById(id).previousElementSibling;
            
            if (previousDiv != null) {
                let wrapper = document.createElement('div');
                wrapper.innerHTML = document.getElementById(id).previousElementSibling.outerHTML;
                let div = wrapper.firstChild;
                id = div.id;
                
                for (let i = 0; i < nav.length; i++) {
                    nav[i]. classList.remove('is-active');
                }
                
                console.log(document.querySelector("li[data-target='#"+id+"']"));
                
                document.querySelector("li[data-target='#"+id+"']").classList.add('is-active');
            }
        }
        
        gsap.utils.toArray(".js-waypoint").forEach(function(section) {
            gsap.from(section, {
                scrollTrigger: {
                    trigger: section,
                    start: 'top top+=200px',
                    end: 'bottom bottom',
                    onEnter: () => action(section),
                    onEnterBack: () => actionBack(section),
                }
            });
        });
    };   

}, false);
